module.exports = __webpack_public_path__ + "img/back05.09886494.png";